export default "__VITE_ASSET__BSq8MgfU__"